export class login{
    userName:any;
    passWord:any;
}